import { gql } from 'apollo-boost';

export const contentTypesQuery = gql`
    {
        getContentTypes {
            uuid
            displayName
            slug
            fields {
                uuid
                displayName
                slug
                controls {
                    fieldType
                    displayField
                    linkUuid
                    settings {
                        placeholder
                        helpText
                        selectOptions
                    }
                }
            }
        }
    }
`;
